export class Strings {
  // 'path' -> 'path/'
  static ensureTrailingSlash(path: string): string {
    if (!path) {
      return '';
    }
    return path.slice(-1) === '/' ? path : path + '/';
  }

  // 'path' -> '/path'
  static ensureLeadingSlash(path: string): string {
    if (!path) {
      return '';
    }
    return path.indexOf('/') === 0 ? path : '/' + path;
  }

  // "/path" -> "path"
  static removeLeadingSlash(path: string): string {
    if (!path) {
      return '';
    }
    return path.indexOf('/') === 0 ? path.substring(1) : path;
  }

  // "path/" -> "path"
  static removeTrailingSlash(path: string): string {
    if (!path) {
      return '';
    }
    return path.slice(-1) === '/' ? path.slice(0, -1) : path;
  }
}


export function ensureUrlEndsWithIndexHtml(uri: string) {
  if (uri.endsWith('/index.html')) {
    return uri;
  }
  return `${Strings.removeTrailingSlash(uri)}/index.html`
}

